import { PageTitle } from "@/components/pageTitle";

export const Principle = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#F9FAFF] to-[#FFFFFF]">
      <div className="w-[1920px] px-[150px] pb-[80px]  pt-[47px]">
        <PageTitle title="光年K-WAN全球网络加速原理" />

        <img
          src="/imgs/kwan/principle.png"
          className="w-[100%] h-[860px] mt-[140px]"
        />
      </div>
    </div>
  );
};
